// Powerpuff Girls inspired palette — bright, saturated, black-outlined.
// One theme only (the app no longer switches light/dark).

export const lightTheme = {
  // core surfaces
  body: '#FFF1F8',       // Bubbles-sky-adjacent cream-pink page background
  panel: '#FFFFFF',      // card / panel surface
  text: '#241B2F',        // near-black plum, softer than pure #000 on pink

  // the three girls
  blossom: '#FF3E8E',     // hot pink / red-pink
  bubbles: '#4FC9FF',     // sky blue
  buttercup: '#8CE04A',   // lime green

  // supporting accents
  yellow: '#FFD93D',
  lavender: '#C9A6FF',
  black: '#1A1420',

  fontFamily: "'Karla', sans-serif",
  pixelFont: "'Press Start 2P', 'Karla', sans-serif",

  // legacy fields still read by a couple of older components
  bodyRgba: '255, 241, 248',
  textRgba: '26, 20, 32',
}

// Kept as an alias so any stray `DarkTheme` import still resolves —
// this app now runs a single palette instead of light/dark switching.
export const DarkTheme = lightTheme
